import React, { Component } from 'react';
import PropTypes from 'prop-types';
import assign from 'object-assign';
import { Link } from 'react-router';

import DetailView from '../Common/DetailView';
// elements
import { Card, CardHeader, CardText } from 'material-ui/Card';
import EventWrapper from '../Event/EventWrapper';
import EventDialog from '../Event/EventDialog';

import ErrorSnackbar from '../Common/ErrorSnackbar';
import EventDialogCreate from '../Event/EventDialogCreate';

import BigCalendar from 'react-big-calendar';
import moment from 'moment';
// icons
import InfoIcon from 'material-ui/svg-icons/action/info';
import ScheduleIcon from 'material-ui/svg-icons/communication/clear-all';
import CalendarIcon from 'material-ui/svg-icons/action/date-range';

import SettingsIcon from 'material-ui/svg-icons/action/settings';
// constants
import ROLES from '../../constants/Roles';
import { statusColours } from '../../constants/ColourConstants';
// business logic
import buildContextMenu from '../Common/BuildContextMenu';
import VenueActions from '../../actions/VenueActionCreator';
import EventActions from '../../actions/EventActionCreator';
import VenueEventStore from '../../stores/VenueEventStore';
import VenueLocationStore from '../../stores/VenueLocationStore';
import VenueStore from '../../stores/VenueStore';
import { getISODateLimits as getDateLimits } from '../../utils/Date';

BigCalendar.momentLocalizer(moment);

const style = {
    icon: {
        height: '32px',
        width: '32px',
    }
};

class VenueCalendar extends Component {


    constructor (props) {
        super(props);
        this.state = {
            details: {
                id: '',
                name: '',
                description: '',
            },
            events: [],
            locations: [],
            actions: [],
            menuItems: [
                {
                    link: '/dashboard/venue/' + this.props.routeParams.id,
                    icon: <InfoIcon />,
                    label: 'Preview',
                },
                {
                    type: 'divider'
                },
                {
                    link: '/dashboard/venue/' + this.props.routeParams.id + '/settings',
                    icon: <SettingsIcon />,
                    label: 'Settings',
                    condition: {
                        roles: [ROLES.ADMIN]
                    }
                },
            ],
            links: {
                back: '/dashboard/venue/' + this.props.routeParams.id,
                edit: '',

            },
            dialog: {
                open: false,
                start: null,
                end: null,
                eventDates: null
            }
        };
        this.onVenueChange = this.onVenueChange.bind(this);
        this.onEventsChange = this.onEventsChange.bind(this);
        this.onNavigate = this.onNavigate.bind(this);
        this.onLocationsChange = this.onLocationsChange.bind(this);
        this.onDateSelect = this.onDateSelect.bind(this);
        this.onDialogClose = this.onDialogClose.bind(this);
        this.onEventFormSubmit = this.onEventFormSubmit.bind(this);
        this.convertEvent = this.convertEvent.bind(this);
    }

    componentDidMount() {
        VenueStore.addChangeListener(this.onVenueChange);
        VenueActions.getById(this.props.routeParams.id);

        VenueEventStore.addChangeListener(this.onEventsChange);
        VenueActions.getEvents(this.props.routeParams.id, getDateLimits(new Date(), 'month'));

        this.venueLocationListener = VenueLocationStore.addListener(this.onLocationsChange);
        VenueActions.getLocations(this.props.routeParams.id);

        this.setState({actions: buildContextMenu(this.state.menuItems, this.context.auth)});
    }

    componentWillUnmount() {
        VenueEventStore.removeChangeListener(this.onEventsChange);
        VenueStore.removeChangeListener(this.onVenueChange);

        this.venueLocationListener.remove();
    }

    render () {
        const scrollToTime = new Date();
        scrollToTime.setHours(6);

        return(

            <DetailView
                backButton={true}
                backTo={this.state.links.back}
                actions={this.state.actions}
            >
                <div className="cent-cards">
                    <Card className="cent-card">
                        <CardHeader
                            title="Calendar"
                            subtitle={this.state.details.name}
                            avatar={<CalendarIcon style={style.icon} color={statusColours.default}/>}
                        />
                        <div className="cent-card-header-buttons">
                            <Link to={`/dashboard/venue/${this.props.routeParams.id}/schedule`}>
                                <ScheduleIcon className='cent-icon' color={statusColours.default}/>
                                </Link>
                        </div>
                        <CardText className="cent-card-calendar">
                            <BigCalendar
                                selectable={this.context.auth.isAdmin()}
                                views={['month', 'week', 'day']}
                                events={this.state.events}
                                defaultView='month'
                                defaultDate={new Date()}
                                onNavigate={this.onNavigate}
                                eventPropGetter={this.eventPropGetter}
                                onSelectSlot={this.onDateSelect}
                                components={{eventWrapper: EventWrapper}}
                                scrollToTime={scrollToTime}
                            />
                        </CardText>
                    </Card>
                </div>
                {!!this.state.dialog.open && (
                    <EventDialogCreate
                        title='New event'
                        open={this.state.dialog.open}
                        eventDates={this.state.dialog.eventDates}
                        locations={this.state.locations}
                        start={this.state.dialog.start}
                        end={this.state.dialog.end}
                        onClose={this.onDialogClose}
                        onSave={this.onEventFormSubmit}
                    />
                )}
                <EventDialog
                    event={this.state.selectedEvent}
                    onClose={() => this.onSelectEvent()}
                    editLink={(ROLES.ADMIN && this.state.selectedEvent && `/dashboard/event/${this.state.selectedEvent.id}/edit`) || null}
                />
                <ErrorSnackbar/>
            </DetailView>
        )
    }

    onVenueChange() {
        const details = VenueStore.getById(this.props.routeParams.id);
        if (details !== undefined) {
            const state = assign(this.state, {details: details});
            this.setState(state);
        }
    }

    onEventsChange() {
        const events = VenueEventStore.getByVenue(this.props.routeParams.id);
        if (events !== undefined) {
            this.setState({events: events.map(this.convertEvent)});
        }
    }

    onNavigate(date, view) {
        VenueActions.getEvents(this.props.routeParams.id, getDateLimits(date, view));
    }

    onSelectEvent(eventId) {
        this.setState({selectedEvent: (!!eventId && VenueEventStore.getById(eventId)) || null});
    }

    eventPropGetter(event, startDate, endDate, selected) {
        let prop = {};
        if (!!event.class) {
            if (endDate.getTime() < Date.now()) {
                prop.className = `${event.class}_`;
            } else {
                prop.className = event.class;
            }
        } else if (endDate.getTime() < Date.now()) {
            prop.className = 'past-event';
        }
        return prop;
    }

    onLocationsChange() {
        const locations = VenueLocationStore.getByVenue(Number(this.props.routeParams.id));
        if (locations !== undefined) {
            this.setState({locations});
        }
    }

    onDateSelect(slotInfo) {
        const options = {weekday: 'short', year: 'numeric', month: 'short', day: 'numeric'};
        const startDate = slotInfo.start.toLocaleString('en-GB', options).substring(0,11);
        const endDate = slotInfo.end.toLocaleString('en-GB', options).substring(0,11);

        let dialog = {};
        dialog.start = slotInfo.start;
        dialog.end = slotInfo.end;
        dialog.eventDates = startDate;
        if (startDate !== endDate) {
            dialog.eventDates = `${dialog.eventDates} - ${endDate}`;
        }
        dialog.open = true;

        this.setState({dialog});
    }

    onDialogClose() {
        this.setState({dialog: assign({}, this.state.dialog, {open: false})});
    }

    onEventFormSubmit(data) {
        data.timeStart = data.timeStart.toString().replace(/\s\([^)]+\)/, '');
        data.timeEnd = data.timeEnd.toString().replace(/\s\([^)]+\)/, '');
        data.description = '';
        data.venueId = this.props.routeParams.id;
        data.periodic = false;

        EventActions.save(data);
        VenueActions.getEvents(this.props.routeParams.id, getDateLimits(new Date(), 'month'));

        this.onDialogClose();
    }

    convertEvent(event) {
        const eventData = {
            id:    event.id,
            start: new Date(event.eventStart || event.timeStart),
            end:   new Date(event.eventEnd || event.timeEnd),
            title: event.name,
            url:   `/dashboard/event/${event.id}`,
            selectAction: () => this.onSelectEvent(event.id)
        };
        if (eventData.start.toLocaleTimeString() === "00:00:00" && eventData.end.toLocaleTimeString() === "00:00:00") {
            eventData.allDay = true;
        }

        if (!!event.location) {
            const styleId = event.locationId.toString().substr(-1, 1);
            eventData.class = `style_${styleId}`;
        }

        return eventData;
    };

}

VenueCalendar.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default VenueCalendar;
